import { render } from "./Aiassitant.vue?vue&type=template&id=b725f896&scoped=true"
import script from "./Aiassitant.vue?vue&type=script&lang=js"
export * from "./Aiassitant.vue?vue&type=script&lang=js"

import "./Aiassitant.vue?vue&type=style&index=0&id=b725f896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b725f896"]])

export default __exports__